<template>
  <div>
    <Header :sel='3' @changePhone="changePhone" />
    <!--neirong-->
    <div :class="['cd-main-content', showPhone ? 'nav-is-visible' : '']">


      <div class="bg2">
        <div class="main3">

          <div class="bread">
            <div class=""></div>
            <div class="bread_c"><a href="javascript:void(0);" @click="goNext('/')">主页> </a> <a
                href="javascript:void(0);">7.8宣传</a> </div>
          </div>
          <div class="img-box">
            <div class="img-box-cont">
              <img v-for="item in bannerList" :src="item.url" alt="">
            </div>
            <div v-if="moreType" class="img-box-cont" style="margin-top: 20px;">
              <img v-for="item in bannerList1" :src="item.url" alt="">
            </div>
            <div v-else class="img-box-more" @click="moreImg">
              <span>展示更多</span>
            </div>

            <!-- <div class="img-box">
              <img v-for="item in bannerList1" :src="item.url" alt="">
            </div> -->

          </div>
          <ul class="news_list">
            <li v-for="item in list"><span>{{ item.publishTime }}</span> <a href="javascript:void(0);"
                @click="goDetail(item.id, item.linkUrl)">{{ item.title }}</a> </li>

          </ul>
          <ul id="page">
            <li><a href="javascript:void(0)" @click="goPage('home')">首页</a></li>
            <li><a href="javascript:void(0)" @click="goPage('last')">上一页</a></li>
            <li v-for="index in indexs" @click="goPage(index)"><a :class="pageNum == index ? 'pagesel' : ''"
                href="javascript:void(0)">{{ index }}</a>
            </li>
            <li><a href="javascript:void(0)" @click="goPage('next')">下一页</a></li>
            <li><a href="javascript:void(0)" @click="goPage('end')">尾页</a></li>
            <li class="total">共{{ totalPage }}页</li>
          </ul>

        </div>

      </div>

      <Footer />
    </div>



    <!--neirong-->


  </div>
</template>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'
import axios from 'axios';


import {
  categorysortPage,
  articleList
} from '@/api/reqFetch.js'
import NewList from './newList.vue';

export default {
  name: '',
  layout: '',
  components: {
    Footer,
    Header,
  },
  data() {
    return {
      id: '',
      detail: {},
      showPhone: false,
      pdfUrl: '',
      pdfDoc: null,
      pageNum: 1,
      pageCount: 0,
      list: [],
      indexs: [],
      totalPage: 0,
      moreType: false,
      bannerList: [{
        id: 2,
        url: 'https://iaqd-web.oss-cn-qingdao.aliyuncs.com/2026-06-23/1782186143930407.jpg',
      },
      {
        id: 3,
        url: 'https://iaqd-web.oss-cn-qingdao.aliyuncs.com/2026-06-23/1782186233408309.jpg',
      },
      {
        id: 4,
        url: 'https://iaqd-web.oss-cn-qingdao.aliyuncs.com/2026-06-23/1782186302841917.jpg',
      },
      {
        id: 5,
        url: 'https://iaqd-web.oss-cn-qingdao.aliyuncs.com/2026-06-23/1782186372692791.jpg',
      },
      {
        id: 6,
        url: 'https://iaqd-web.oss-cn-qingdao.aliyuncs.com/2026-06-23/1782186421023814.jpg',
      },
      {
        id: 7,
        url: 'https://iaqd-web.oss-cn-qingdao.aliyuncs.com/2026-06-23/178218646071857.jpg',
      }
      ],
      bannerList1: [{
        id: 8,
        url: 'https://iaqd-web.oss-cn-qingdao.aliyuncs.com/2025-07-07/1751881538024654.jpg',
      },
      {
        id: 9,
        url: 'https://iaqd-web.oss-cn-qingdao.aliyuncs.com/2025-07-07/1751881565648166.jpg',
      },
      {
        id: 10,
        url: 'https://iaqd-web.oss-cn-qingdao.aliyuncs.com/2025-07-07/175188155599899.jpg',
      },
      {
        id: 11,
        url: 'https://iaqd-web.oss-cn-qingdao.aliyuncs.com/2025-07-07/1751881572883794.jpg',
      },
      {
        id: 12,
        url: 'https://iaqd-web.oss-cn-qingdao.aliyuncs.com/2025-07-07/1751881579152390.jpg',
      },
      {
        id: 13,
        url: 'https://iaqd-web.oss-cn-qingdao.aliyuncs.com/2025-07-07/1751881587104723.jpg',
      }
      ]
    }
  },

  mounted() {
    // this.getList();
    this.getData()
  },

  methods: {
    goDetail(id, url) {
      if (url) {
        window.open(url, '_blank');
        return
      }
      const route = this.$router.resolve({
        path: '/context',
        query: {
          id: id
        }
      });
      window.open(route.href, '_blank');
    },
    // getList() {
    // 	let par = {
    // 		pageNum: 1,
    // 		pageSize: 50,
    // 		status: 1,
    // 		categoryCode: 5000
    // 	}

    // 	articleList(par).then(res => {
    // 		this.list = res.rows;
    // 	});
    // },
    checkIndex() {
      var left = 1;
      var right = this.totalPage;
      var ar = [];
      if (this.totalPage >= 10) {
        if (this.pageNum > 1 && this.pageNum < this.totalPage - 2) {
          left = this.pageNum - 1
          right = this.pageNum + 1
        } else {
          if (this.pageNum <= 1) {
            left = 1
            right = 10
          } else {
            right = this.totalPage
            left = this.totalPage - 2
          }
        }
      }
      while (left <= right) {
        ar.push(left)
        left++
      }
      this.indexs = ar

    },
    changePhone(val) {
      this.showPhone = val
    },
    goPage(type) {
      if (type == 'home') {
        this.pageNum = 1
      } else if (type == 'end') {
        this.pageNum = Number(this.totalPage)

      } else if (type == 'last') {
        if (this.pageNum > 1) {
          this.pageNum = this.pageNum - 1
        }
      } else if (type == 'next') {
        if (this.pageNum < (this.totalPage)) {
          this.pageNum = this.pageNum + 1
        }
      } else {
        this.pageNum = type
      }
      this.getData()
    },
    getData() {
      let par = {
        pageNum: this.pageNum,
        pageSize: 10,
        status: 1,
        categoryCode: 5000
      }

      articleList(par).then(res => {
        this.list = res.rows;
        this.total = res.total
        this.totalPage = Math.ceil(res.total / 10)
        this.checkIndex();


      });
    },
    moreImg() {
      this.moreType = true;
    },


  }
}
</script>

<style scoped>
/*内容*/
.img-box {
  margin-top: 20px;
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}
.img-box-cont {
  display: flex;
  /* flex-wrap: wrap; */
  justify-content: space-between;
}
.img-box-more {
  color: #666;
  font-size: 14px;
  text-align: center;
  margin-top: 5px;
}
.img-box-more span {
  cursor: pointer;
}
.img-box-more span:hover {
  color: #08649a;
}
.img-box img {
  width: 180px;
}

.img-box img:first-child {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.img-box img:last-child {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.news_list {
  position: relative;
  z-index: 1;
}

.news_list::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url("https://iaqd-web.oss-cn-qingdao.aliyuncs.com/2026-06-23/1782186233408309.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0.5;
  /* 只改变背景图透明度 */
  z-index: -1;
}
</style>